<!--<div #controlStickyMenu></div>-->
<div #stickyMenu>
  <mat-tab-group
    class="flex menu-underline back-grey"
    [selectedIndex]="tabIndex"
    (selectedTabChange)="onTabChanged($event)"
    (click)="clickTab()"
    id="contentStickyMenu"
    #contentStickyMenu
  >
    <mat-tab *ngFor="let litab of tabs" [label]="litab" class="flex-item-grow">
    </mat-tab>
  </mat-tab-group>
</div>
<div id="tab0" class="mt-2" #contSumary>
  <tech-portfolio-sumary id="sumary" #sumary *ngIf="sumary">
  </tech-portfolio-sumary>
</div>
<div id="tab1" class="mt-2" #contPositions>
  <tech-portfolio-positions id="positions" #positions *ngIf="positions">
  </tech-portfolio-positions>
</div>
<div id="tab2" class="mt-2" #contCompositions>
  <tech-portfolio-compositions
    id="compositions"
    #compositions
    *ngIf="compositions"
  >
  </tech-portfolio-compositions>
</div>
<div id="tab3" class="mt-2" #contTrades>
  <tech-portfolio-trades
    id="trades"
    #trades
    *ngIf="trades"
  ></tech-portfolio-trades>
</div>
<div id="tab4" class="mt-2" #contActividades>
  <tech-activities
    id="actividades"
    #actividades
    *ngIf="actividades"
    [portfoliocode]="portfolioCode"
    [initialdate]="initialDate"
    [enddate]="endDate"
  ></tech-activities>
</div>
<!--Credits/Liabilities-->
<div id="tab5" class="mt-2" #contCredits>
  <tech-portfolio-liabilities
    id="credits"
    #credits
    *ngIf="credits"
  ></tech-portfolio-liabilities>
</div>
<!--Diagnosis-->
<div id="tab6" class="mt-2" #contDiagnosis>
  <div
    id="diagnosis"
    #diagnosis
    *ngIf="diagnosis"
  ></div>
</div>
<!--Risk-->
<div id="tab7" class="mt-2" #contRisk *ngIf="risk"></div>
<!--Commissions-->
<div id="tab8" class="mt-2" #contCommissions>
  <div
    id="commissions"
    #commissions
    *ngIf="commissions"
  ></div>
</div>
